/*
 * @Description:规则管理--对象映射规则/接口映射规则
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  启用: 'Enable',
  停用: 'Disable',
  字段: 'Field',
  规则名称: 'Rule Name',
  来源对象: 'Source Object',
  映射字段: 'Mapping Field',
  规则类型: 'Rule Type',
  映射类型: 'Mapping Type',
  映射至对象: 'Mapping To Object',
  映射规则设置: 'Mapping Rule Setting',
  对象映射规则: 'Object Mapping Rule',
  新建映射规则: 'Create New Mapping Rule',
  对象映射规则设置: 'Object Mapping Rule Setting',
  接口映射规则设置: 'Interface Mapping Rule Setting',
  获取规则详情失败: 'Failed to Get Rule Details',
  获取对象列表失败: 'Failed to Get Object List',
  字段属性: 'Field Attributes',
  '字段属性不能为空,请重新设置': 'Field attributes cannot be empty, please reset',
  '请设置选项名称(必填)': 'Please set the option name (required)',
  选项至少保留一项: 'At least one option should be retained',
  暂无视图: 'No view',
  配置同步规则: 'Setting Synchronization Rules',
  ID关联: 'ID Association',
  主属性字段关联: 'Main Attribute Field Association',
  字段映射: 'Field Mapping',
  搜索规则名称: 'Search rule name',
  新建规则: 'Create new rule'
};
